import { useMemo } from 'react';
import useWindowDimensions from './useWindowDimensions';

const MOBILE_MAX_WIDTH = 599; // aligns with MUI default sm breakpoint (600)
const TABLET_MAX_WIDTH = 899; // aligns with MUI default md breakpoint (900)

const useDeviceType = () => {
  const { width } = useWindowDimensions();

  return useMemo(() => {
    const userAgent = navigator.userAgent;
    const isMobileUserAgent = /mobile/i.test(userAgent);
    const isTabletUserAgent = /iPad|Android(?!.*Mobile)|Tablet/i.test(userAgent);

    // Width-based detection is the primary signal so responsive layouts update on resize
    // and work in environments where UA/touch detection is unreliable (e.g., automated tests).
    const isMobile = isMobileUserAgent || (!isTabletUserAgent && width <= MOBILE_MAX_WIDTH);
    const isTablet =
      !isMobile && (isTabletUserAgent || (width > MOBILE_MAX_WIDTH && width <= TABLET_MAX_WIDTH));

    return {
      isMobile,
      isTablet,
      isDesktop: !isMobile && !isTablet,
    };
  }, [width]);
};

export { useDeviceType };
